import React, { forwardRef, memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { StyledKey } from 'components/Keyboard/StyledComponents';

const Key = memo(
  forwardRef(({ keyMeta, content, onEnter }, ref) => {
    const handleEnter = useCallback(() => onEnter(keyMeta), [keyMeta, onEnter]);

    return (
      <StyledKey
        span={keyMeta.span}
        smallFont={keyMeta.smallFont}
        disabled={keyMeta.focusable === false || !content}
        onEnter={handleEnter}
        focusOnMouseEnter
        ref={ref}
      >
        {content || '-'}
      </StyledKey>
    );
  }),
);

Key.propTypes = {
  keyMeta: PropTypes.object.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onEnter: PropTypes.func,
};

export default Key;
